import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`About`}</h1>
    <p>{`Currently I am pursuing my B.Tech in CSE Engineering from Birla Institute of Technology, Mesra. This journey of my life till now has been totally dedicated to coding like in all aspects from being learner to an intermediate level developer in short it's a great start. Coding has been my passion no matter how bad my day gets tapping on the keyboard makes it really good at the end. So, this was about my little journey of learning till now hope to hear about your story soon. :)
Keep Coding !`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      